import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var e = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-320 -68)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000244141H0V19.9998H20V0.000244141Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#338AF3"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.208 12.7083C8.71219 12.7083 7.49961 11.4958 7.49961 9.99999C7.49961 8.5042 8.71219 7.29163 10.208 7.29163C10.6744 7.29163 11.1131 7.40956 11.4963 7.61713C10.8953 7.0294 10.0734 6.66663 9.16633 6.66663C7.32539 6.66663 5.83301 8.15901 5.83301 9.99999C5.83301 11.841 7.32539 13.3333 9.16633 13.3333C10.0734 13.3333 10.8953 12.9706 11.4963 12.3828C11.1131 12.5904 10.6743 12.7083 10.208 12.7083Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M12.292 8.125L12.6507 9.13391L13.6179 8.67414L13.1581 9.64121L14.167 10L13.1581 10.3588L13.6179 11.3259L12.6507 10.8661L12.292 11.875L11.9333 10.8661L10.9662 11.3259L11.4259 10.3588L10.417 10L11.4259 9.64121L10.9662 8.67414L11.9333 9.13391L12.292 8.125Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  e as default
};
